import { useState } from "react";
import { HelpCircle, Mail, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function Support() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const mailtoUrl = `mailto:support@nxtinvoice.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoUrl;
  };

  return (
    <div className="container py-8 max-w-2xl space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold text-foreground mb-1">Support</h1>
        <p className="text-muted-foreground">
          Haben Sie Fragen oder benötigen Hilfe? Kontaktieren Sie unser Team.
        </p>
      </div>

      {/* Quick contacts */}
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-border bg-card p-5">
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10">
              <Mail className="h-4 w-4 text-primary" />
            </div>
            <span className="font-semibold text-foreground">E-Mail</span>
          </div>
          <a href="mailto:support@nxtinvoice.de" className="text-sm text-primary hover:underline">
            support@nxtinvoice.de
          </a>
        </div>
        <div className="rounded-xl border border-border bg-card p-5">
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10">
              <HelpCircle className="h-4 w-4 text-primary" />
            </div>
            <span className="font-semibold text-foreground">Reaktionszeit</span>
          </div>
          <p className="text-sm text-muted-foreground">Innerhalb von 24 Stunden</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="rounded-xl border border-border bg-card p-6 space-y-4">
        <div className="space-y-2">
          <Label htmlFor="subject">Betreff</Label>
          <Input
            id="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Worum geht es?"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="message">Nachricht</Label>
          <Textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Beschreiben Sie Ihr Anliegen…"
            rows={6}
            required
          />
        </div>

        <Button type="submit" className="gap-2">
          <Send className="h-4 w-4" />
          E-Mail senden
        </Button>
      </form>
    </div>
  );
}
